const SingleProjectCard = ({project}) => {
    const title = project.title; 
    const year = project.year;
    const bannerUrl = project.cardBanner;
    const shortdescription = project.shortdescription;
    const tags = project.developmentType;
    const projectLogo = project.client.logo_color;
    const popular = project.popular;
  return (
      <div className="projectCard" >
        <div className="project-card-banner" style={{ backgroundImage: `url(/images/projects/${bannerUrl})`}}>
          { projectLogo === "" ? null :
            <div className="cardProjectLogoContainer">
              <img src={"/images/logos/"+projectLogo} className="cardProjectLogo" />
            </div>
          }
          <div className="project-card-content">
            <h5>{title}</h5>
            <p>{shortdescription}</p>
          </div>
        </div>
      </div>
    );
  };
  
export default SingleProjectCard;